/* KonpreShop · OutletShop rescate (2-nov-2026): etiquetas sobre la portada, entrada de las personas en las puertas y flechas del riel de invierno.
   Sin librerías. Se carga desde varias secciones: solo corre una vez. */
(function () {
  if (window.__ksOutletRescate) return;
  window.__ksOutletRescate = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1 · Etiquetas sobre la foto del héroe ---------- */
  function parsePts(str) {
    if (!str) return null;
    var a = str.split(',');
    if (a.length < 2) return null;
    var x = parseFloat(a[0]), y = parseFloat(a[1]);
    if (isNaN(x) || isNaN(y)) return null;
    return { x: x / 100, y: y / 100 };
  }
  function parseBoxes(str) {
    if (!str) return [];
    return str.split(';').map(function (s) {
      var a = s.split(',').map(parseFloat);
      return a.length === 4 && a.every(function (n) { return !isNaN(n); }) ? a : null;
    }).filter(Boolean);
  }
  function hit(a, b) { return a.l < b.r && a.r > b.l && a.t < b.b && a.b > b.t; }
  function pad(r, p) { return { l: r.l - p, t: r.t - p, r: r.r + p, b: r.b + p }; }

  function variant() {
    if (matchMedia('(max-width: 749px)').matches) return 'celular';
    if (matchMedia('(max-width: 1199px)').matches) return 'tableta';
    return 'escritorio';
  }

  function setupSpots(data) {
    var hero = null;
    var all = document.querySelectorAll('.ks-editorial');
    for (var i = 0; i < all.length; i++) {
      if (all[i].compareDocumentPosition(data) & Node.DOCUMENT_POSITION_FOLLOWING) hero = all[i];
    }
    if (!hero) return;
    var img = hero.querySelector('.ks-editorial__media img');
    if (!img) return;
    var layer = document.createElement('div');
    layer.className = 'ks-or-spots';
    var spots = Array.prototype.slice.call(data.querySelectorAll('.ks-or-spot'));
    spots.forEach(function (s) { layer.appendChild(s); });
    hero.appendChild(layer);
    var caras = {
      escritorio: parseBoxes(data.getAttribute('data-caras-escritorio')),
      tableta: parseBoxes(data.getAttribute('data-caras-tableta')),
      celular: parseBoxes(data.getAttribute('data-caras-celular'))
    };

    function layout() {
      if (!img.naturalWidth) return;
      var v = variant();
      var hr = hero.getBoundingClientRect();
      var ir = img.getBoundingClientRect();
      if (!ir.width || !ir.height) return;
      var cs = getComputedStyle(img);
      var op = (cs.objectPosition || '50% 50%').split(' ');
      var px = parseFloat(op[0]) / 100, py = parseFloat(op[1] || '50%') / 100;
      if (isNaN(px)) px = .5; if (isNaN(py)) py = .5;
      var ar = img.naturalWidth / img.naturalHeight;
      var cw = ir.width, ch = ir.height;
      var dw, dh;
      if (cw / ch > ar) { dw = cw; dh = cw / ar; } else { dh = ch; dw = ch * ar; }
      var ox = ir.left - hr.left + (cw - dw) * px;
      var oy = ir.top - hr.top + (ch - dh) * py;
      function toPx(fx, fy) { return { x: ox + fx * dw, y: oy + fy * dh }; }
      /* zona visible de la foto (sin lo que tapa el encabezado pegado) */
      var vis = { l: ir.left - hr.left + 10, t: ir.top - hr.top + 10, r: ir.right - hr.left - 10, b: ir.bottom - hr.top - 10 };
      /* obstáculos: caras + textos y botones del héroe */
      var obst = caras[v].map(function (c) {
        var a = toPx(c[0], c[1]), b = toPx(c[2], c[3]);
        return { l: a.x, t: a.y, r: b.x, b: b.y };
      });
      var copy = hero.querySelectorAll('.ks-editorial__copy > *, .ks-editorial__copy .ks-editorial__actions > *, .ks-editorial__copy h1, .ks-editorial__copy p');
      Array.prototype.forEach.call(copy, function (el) {
        var r = el.getBoundingClientRect();
        if (r.width && r.height && getComputedStyle(el).visibility !== 'hidden') obst.push(pad({ l: r.left - hr.left, t: r.top - hr.top, r: r.right - hr.left, b: r.bottom - hr.top }, 10));
      });
      var placed = [];
      spots.forEach(function (s) {
        var pt = parsePts(s.getAttribute('data-' + v));
        s.classList.remove('is-on', 'is-left');
        if (!pt) return;
        var p = toPx(pt.x, pt.y);
        var dot = { l: p.x - 13, t: p.y - 13, r: p.x + 13, b: p.y + 13 };
        if (dot.l < vis.l || dot.r > vis.r || dot.t < vis.t || dot.b > vis.b) return;
        if (obst.some(function (o) { return hit(dot, o); })) return;
        s.style.left = p.x + 'px';
        s.style.top = p.y + 'px';
        s.classList.add('is-on');
        var lbl = s.querySelector('.ks-or-spot__lbl');
        var lw = lbl.offsetWidth, lh = lbl.offsetHeight;
        var right = { l: p.x + 17, t: p.y - lh / 2, r: p.x + 17 + lw, b: p.y + lh / 2 };
        var left = { l: p.x - 17 - lw, t: p.y - lh / 2, r: p.x - 17, b: p.y + lh / 2 };
        function ok(r) {
          return r.l >= vis.l && r.r <= vis.r && r.t >= vis.t && r.b <= vis.b &&
            !obst.some(function (o) { return hit(r, o); }) &&
            !placed.some(function (o) { return hit(pad(r, 6), o); });
        }
        var pref = s.getAttribute('data-lado') === 'izq' ? [left, right] : [right, left];
        var pick = ok(pref[0]) ? pref[0] : (ok(pref[1]) ? pref[1] : null);
        if (!pick) { s.classList.remove('is-on'); return; }
        if (pick === left) s.classList.add('is-left');
        placed.push(pick, dot);
      });
      layer.classList.add('is-ready');
    }
    var raf = 0;
    function queue() { cancelAnimationFrame(raf); raf = requestAnimationFrame(layout); }
    if (img.complete) queue(); else img.addEventListener('load', queue);
    img.addEventListener('load', queue);
    window.addEventListener('resize', queue, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(queue).observe(hero);
    setTimeout(queue, 600);
    setTimeout(queue, 1800);
  }

  /* ---------- 2 · Personas que entran en las puertas ---------- */
  function setupDoors(sec) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var doors = sec.querySelectorAll('.ks-or-door');
    sec.classList.add('is-armed');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    Array.prototype.forEach.call(doors, function (d) {
      var r = d.getBoundingClientRect();
      if (r.top < innerHeight * .88 && r.bottom > 0) d.classList.add('is-in'); else io.observe(d);
    });
  }

  /* ---------- 3 · Flechas del riel ---------- */
  function setupRail(wrap) {
    var rail = wrap.querySelector('[data-ks-or-rail]');
    var prev = wrap.querySelector('[data-ks-or-prev]');
    var next = wrap.querySelector('[data-ks-or-next]');
    if (!rail) return;
    function step() { var c = rail.querySelector('.ks-or-card'); return c ? (c.offsetWidth + 14) * Math.max(1, Math.floor(rail.clientWidth / (c.offsetWidth + 14)) - 1 || 1) : 300; }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ks-or-spots]'), setupSpots);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ks-or-doors]'), setupDoors);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ks-or-rail-wrap]'), setupRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
